export const sortPriorities = (a, b) => {
  if (a.priority === b.priority) return 0;
  if (a.priority === 'HIGH') return -1;
  if (b.priority === 'HIGH') return 1;
  if (a.priority === 'NORMAL') return -1;
  if (b.priority === 'NORMAL') return 1;
  return 1;
}

export const defaultSort = (a, b) => {
  a = (a === null || a === undefined) ? -Infinity : a
  b = (b === null || b === undefined) ? -Infinity : b
  a = a === 'string' ? a.toLowerCase() : a
  b = b === 'string' ? b.toLowerCase() : b
  if (a > b) {
    return 1
  }
  if (a < b) {
    return -1
  }
  return 0
}



// WEBPACK FOOTER //
// ./src/helpers/sorting.js